import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SystemMessageService } from '../../services/system-message.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AuthService } from '../auth.service';
import { DateTime } from 'luxon';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'flow-confirm-email',
  templateUrl: './confirm-email.component.html',
  styleUrls: ['./confirm-email.component.scss'],
})
export class ConfirmEmailComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  loadingCE = false;
  navigating = false;
  hide = true;
  form: FormGroup; // Declare the email form variable
  currentYear = DateTime.now().year;

  constructor(
    public authService: AuthService,
    private router: Router,
    private systemMessageService: SystemMessageService,
    private formBuilder: FormBuilder // Inject the FormBuilder
  ) {}

  ngOnInit() {
    if (this.authService.isLoggedIn()) {
      this.router.navigate(['/login']);
    }

    // Create the email form with validation
    this.form = this.formBuilder.group({
      email: [''],
    });
  }

  onConfirmEmail() {
    if (this.form.invalid) {
      return;
    }

    this.loadingCE = true;
    const email = this.form.value.email;

    this.authService
      .resetPassword(email)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (resp: string) => {
          this.loadingCE = false;
          this.systemMessageService.success(resp);
          this.router.navigateByUrl('/login');
        },
        error: () => {
          this.loadingCE = false;
        },
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
